import Component from '@glimmer/component';

import styles from './product-overlay.module.css';

interface HotelBenchmarkInsightProductOverlaySignature {
  Args: {
    position: 'bottom' | 'top' | 'center';
  };
  Blocks: {
    default: [];
  };
}

export default class HotelBenchmarkInsightProductOverlay extends Component<HotelBenchmarkInsightProductOverlaySignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get contentPositionModifier() {
    return styles[`product-overlay__content--${this.args.position}`];
  }

  <template>
    <div class={{styles.product-overlay}}>
      <div class={{styles.product-overlay__background}} />

      <div
        class="{{styles.product-overlay__content}}
          {{this.contentPositionModifier}}
          "
      >
        {{yield}}
      </div>
    </div>
  </template>
}
